module.exports = __webpack_public_path__ + "1793882494189/images/line-awesome.131b7f1.svg";